import {ROLE} from "../shared/utils/enum";
import {
    Home,
    Hack,
    Refund,
    CSV,
    LunchFairy,
    InAppProductUpload,
    TimestampConverter,
    LogStreamPage,
    ReceiptFinder,
    JsonParser,
} from "../pages";

import {playerRoutes} from "../features/player/player.route";
import {eventRoutes} from "../features/events/event.route";
import {noticeRoutes} from "../features/banners/notice.route";
import {couponRoutes} from "../features/coupon/coupon.route";
import {csRoutes} from "../features/cs/cs.route";
import {pushRoutes} from "../features/message/push.route";
import {campaignRoutes} from "../features/campaign/campaign.route";
import {pushCampaignRoutes} from "../features/pushCampaign/pushCampaign.route";
import {logsRoutes} from "../features/logs/logs.route";
import {shopPackageRoutes} from "../features/storeManager/shopPackage.route";
import {itemProbabilityRoutes} from "../features/probability/itemProbability.route";
import {countryRoutes} from "../features/country/country.route";
import {statisticsRoutes} from "../features/statistics/statistics.route";
import {adminRoutes} from "../features/admins/admin.route";
import {ProtectedRoute} from "./ProtectedRoute";
import {playerCopyRoutes} from "../features/player/playerCopy.route";
import {passMasterRoutes} from "../features/gameManager/seasonPass/passMaster.route";
import {badgeMasterRoutes} from "../features/gameManager/badge/badgeMaster.route";
import {mergeEventMasterRoutes} from "../features/gameManager/mergeEvent/mergeEventMaster.route";
import {seasonThemeMasterRoutes} from "../features/gameManager/seasonTheme/seasonThemeMaster.route";
import {serverInfoRoutes} from "../features/serverInfo/serverInfo.route";
import {characterPackageRoutes} from "../features/gameManager/characterPackage/characterPackage.route";
import {popupMasterRoutes} from "../features/gameManager/openPopup/popupMaster.route";
import {trophyChallengeRoutes} from "../features/gameManager/trophyChallenge/trophyChallenge.route";

const routesConfig = [
    // --- 메인 ---
    {path: "/", component: <Home/>, role: null},

    // --- 운영 관리 ---
    playerRoutes,
    playerCopyRoutes,

    // --- 이벤트 ---
    eventRoutes,

    // --- 공지사항 ---
    noticeRoutes,

    // --- 쿠폰 ---
    couponRoutes,

    // --- 고객 센터 ---
    csRoutes,

    // --- 푸쉬 ---
    pushRoutes,

    // --- 전체 우편 ---
    campaignRoutes,

    // --- 푸시 캠페인 ---
    pushCampaignRoutes,

    // --- 로그 ---
    logsRoutes,

    // --- 상점 관리 ---
    shopPackageRoutes,

    // --- 확률표 관리 ---
    itemProbabilityRoutes,

    // --- 게임 운영 관리 ---
    passMasterRoutes,
    badgeMasterRoutes,
    mergeEventMasterRoutes,
    seasonThemeMasterRoutes,
    characterPackageRoutes,
    popupMasterRoutes,
    trophyChallengeRoutes,

    // --- 서버 정보 관리 ---
    serverInfoRoutes,

    // --- 기타 단일 페이지 ---
    {path: "/csv", component: <CSV/>, role: ROLE.ADMIN},
    // {path: "/serverInfo", component: <ServerInfo/>, role: ROLE.ADMIN},

    // --- 국가/언어 관리 ---
    countryRoutes,

    // --- 관리자 관리 ---
    adminRoutes,

    // --- 통계 ---
    statisticsRoutes,

    // --- 기타 기능 ---
    {path: "/hack", component: <Hack/>, role: ROLE.DEVELOP},
    {path: "/refund", component: <Refund/>, role: ROLE.DEVELOP},
    {path: "/receiptFinder", component: <ReceiptFinder/>, role: ROLE.DEVELOP},
    {path: "/lunchFairy", component: <LunchFairy/>, role: ROLE.NEWBIE},
    {path: "/inApp", component: <InAppProductUpload/>, role: ROLE.DEVELOP},
    {path: "/timestampConverter", component: <TimestampConverter/>, role: ROLE.NEWBIE},
    {path: "/json", component: <JsonParser/>, role: ROLE.NEWBIE},

    // --- 게임 ---
    // gameRoutes,
    // soloGameRoutes,
    // {path: "/numberBaseball", component: <NumberBaseball/>, role: ROLE.NEWBIE},
    // {path: "/suika", component: <SuikaGame/>, role: ROLE.NEWBIE},
    // {path: "/sudoku", component: <Sudoku/>, role: ROLE.NEWBIE},
    {path: "/logStream", component: <LogStreamPage/>, role: ROLE.DEVELOP}
];

const generateRoutes = (routes) => {
    return routes.map(({path, component, role, children}) => {
        const element = role ? (
            <ProtectedRoute role={role}>
                {component}
            </ProtectedRoute>
        ) : component;

        return {
            path,
            element,
            children: children ? generateRoutes(children) : null,
        };
    });
};

export const children = generateRoutes(routesConfig);